import { wait, } from '@tymia/shared';
function networkError(httpStatus, message) {
    return {
        status: 'network error',
        httpStatus,
        message,
    };
}
export function apiCall(method, url, globalProps) {
    async function performRequest(body) {
        try {
            const response = await fetch(url, {
                method,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Version': process.env.RELEASE_VERSION ?? 'unknown',
                    'X-Url-Path': window.location.href,
                },
                body: method === 'GET' || body === undefined
                    ? undefined
                    : JSON.stringify(body),
            });
            switch (response.status) {
                case 200:
                case 201:
                case 202:
                case 203:
                case 206:
                case 207:
                case 208:
                case 226:
                    return {
                        value: await response.json(),
                        shouldRetry: false,
                    };
                case 204:
                case 205:
                    return {
                        value: undefined,
                        shouldRetry: false,
                    };
                case 400:
                case 403:
                    return {
                        value: await response.json(),
                        shouldRetry: false,
                    };
                case 408:
                case 425:
                case 429:
                case 500:
                case 502:
                case 503:
                case 504:
                    return {
                        value: networkError(response.status, await response.text()),
                        shouldRetry: true,
                    };
                default:
                    return {
                        value: networkError(response.status, await response.text()),
                        shouldRetry: false,
                    };
            }
        }
        catch (error) {
            return {
                value: networkError(0, error instanceof Error
                    ? error.message
                    : String(error)),
                shouldRetry: true,
            };
        }
    }
    return async function call(body, localProps) {
        const retryDelays = localProps?.retry
            ?? globalProps?.retry
            ?? [];
        let result = await performRequest(body);
        for (const delay of retryDelays) {
            if (!result.shouldRetry) {
                return result.value;
            }
            await wait(delay);
            result = await performRequest(body);
        }
        return result.value;
    };
}
//# sourceMappingURL=apiCall.js.map